import React, {useState, useEffect} from 'react'
import NavJudul from 'components/componentsmall/nav_judul'
import './style.css'
import FormInput from 'components/componentsmall/form_input'
import FormPass from 'components/componentsmall/form_pass'
import {Link, useHistory} from 'react-router-dom'
import Animated from 'components/componentsmall/form_bg'
import swal from 'sweetalert';
import { API_URL } from 'api'


export default function Daftar() {
    const [phone_number, setPhone_number] = useState("")
    const [password, setPassword] = useState("")
    const history = useHistory()

    useEffect(() => {
        if(localStorage.getItem('user-info')) {
            // history.push("/dashboard")
        }
    })

    async function login(e) {
        e.preventDefault();
        let item = {phone_number, password}
        console.log(item)
        let result = await fetch(`${API_URL}/api/reseller/login`, {
            method: 'POST',
            body: JSON.stringify(item),
            headers: {
                "Content-Type":'application/json',
                "Accept":'application/json'
            }
        })
         if(!result.ok) {
             swal({text:"maaf no hp atau password anda masukkan tidak valid!", icon:"error"})
         } else {
            result = await result.json()
             localStorage.setItem("user-info", JSON.stringify(result.access_token))
             history.push('/dashboard')
         }

    }

    return (
        <>
            <Animated />
            <div className="phone-login">
                <img src="asset/login/ass-phone.png" alt="phone" />
            </div>
            <div id="login" className="form-daftar">
                <div className="form-content">
                    <NavJudul />
                    <div className="gambar">
                    </div>
                    <h6>Masuk</h6>
                    <p className="paragraph">Belum punya akun Malmora? <span><Link to="/daftar">Daftar</Link></span></p>
                    <FormInput lable="Nomor HP" cName="form-control" type="text" place="Nomor HP Anda" value={phone_number} onChange={(e) => setPhone_number(e.target.value)} />
                    <br />
                    <FormPass lablePass="Kata Sandi" placePass="Kata Sandi Anda" value={password} onChange={(e) => setPassword(e.target.value)} />
                    <FormInput cLable="lupa-sandi text-right" onClickInput={login} lable="Lupa kata sandi?" cName="tombol" type="submit" value="Masuk"/>
                    <FormInput lable="atau masuk dengan" cLable="option" cName="tombol_google" type="button" cImg="btn_google" src="asset/home/icons/google.svg" alt="google" value="Google"/>
                    <div className="content_link">
                        <p>Apakah kamu Supplier? <br />
                        <span>Masuk Sebagai Supplier</span></p>
                        <p>Butuh Bantuan? <span>Customer Care</span> </p>
                    </div>
                </div>
            </div>
            <div id="text-span" className="text-span">
                2020 Malmora
            </div>
        </>
    )
}
